import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class PanelGuard implements CanActivate {
  constructor(private oidcSecurityService: OidcSecurityService, private router: Router, private apiService: ApiService) {}

  canActivate(): Observable<boolean | UrlTree> {
    
    // Check if the user is authenticated
    return this.oidcSecurityService.checkAuth().pipe(
      map((isAuthenticated) => {
        // console.log('******', isAuthenticated);
        if (isAuthenticated.isAuthenticated) {
          this.apiService.isUserAdmin().pipe(
            map((role) => {
              debugger
              if (role || role != false) {
                return this.router.createUrlTree(['/admin/dashboard']);
                // return true;
              } else {
                this.router.createUrlTree(['/forbidden']);
                return false;
              }
            })
          );
          // return true; // Allow access
        } else {
          // Redirect to the login page if not authenticated
          return this.router.createUrlTree(['/login']);
        }
      })
    );
  }
}
